import React from 'react';
import Image from 'next/image';

import ContentImageActions from './ContentImageActions';

import { Heading } from '@/components/design/heading';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';
import useTranslation from '@/hooks/useTranslation';
import ImageIcon from '@/svgs/image.svg';

type Props = {
  images: string[];
  content_id: string;
};

const ContentSingleImage = ({ image }: { image: string }) => {
  return (
    <div className="relative w-full aspect-[1/1] rounded-[12px] overflow-hidden">
      <Image src={image} alt="Image" fill className="object-contain" />
    </div>
  );
};

const ContentImage: React.FC<Props> = ({ images, content_id }) => {
  const { t } = useTranslation('pages.content');

  return (
    <div className="flex flex-col gap-4 min-h-50">
      <Heading title={t('image')} icon={<ImageIcon />} />
      {images.length === 1 && (
        <div className="relative min-h-50">
          <ContentSingleImage image={images[0]} />
          <ContentImageActions
            image={images[0]}
            images={images}
            content_id={content_id}
          />
        </div>
      )}
      {images.length > 1 && (
        <Carousel
          opts={{
            align: 'start',
            direction: 'rtl',
            loop: true,
            dragFree: false,
          }}
        >
          <CarouselContent dir="rtl" className="direction-rtl min-h-[300px]">
            {images.map((image, index) => (
              <CarouselItem
                key={image + index}
                className="relative min-h-50 min-w-full "
              >
                <ContentSingleImage image={image} />
                <ContentImageActions
                  image={image}
                  images={images}
                  content_id={content_id}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      )}
    </div>
  );
};

export default ContentImage;
